import {https, httpsFile} from './http.js';

// export function create_packing_list(page, currentpage,sortby,sortdir, search,status, plant, tab) {
//     return httpsFile().get(`stock-transfer?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&plant=${plant}&tab=${tab}`);
// }

export function index(page, currentpage,sortby,sortdir, search,status, plant, tab,created_by,month_year_filter, isExport = false,filter_receiving_plant) {
    return httpsFile().get(`trucking_list?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}
    &status=${status}&created_by=${created_by}&month_year_filter=${month_year_filter}&isExport=${isExport}&filter_receiving_plant=${filter_receiving_plant}`);
}

export function show_dr_list(page, currentpage,sortby,sortdir, search,status) {
    return httpsFile().get(`dr_list?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}`);
}

export function showTruckTypes(page, currentpage,sortby,sortdir, search,status) {
    return httpsFile().get(`showTruckTypes?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}`);
}

export function showTruckTypeList() {
    return httpsFile().get(`showTruckTypeList`);
}


export function show_dr_details(id,page, currentpage,sortby,sortdir, search,status) {
    return https().get(`show_dr/${id}?page=${page}&currentpage=${currentpage}&search=${search}`);
}

export function show(id,page,currentpage){
    return https().get(`trucking_list/${id}?page=${page}&currentpage=${currentpage}`);
}

export function create_trucking_list(data){
    return https().post(`create_trucking_list`,data);
}

export function assign_dr(data){
    return https().post(`create_dr`,data);
}

export function submitTruckType(data){
    return https().post(`submitTruckType`,data);
}

export function post_trucking_list(data){
    return https().post(`post_trucking_list`,data);
}